import { BaseEntityDTO, IBaseEntityDTO } from './base.entity.dto';
import { IRubricOptionDTO, RubricOptionDTO } from './rubric.option.dto';
import { IRubricSectionDTO, RubricSectionDTO } from './rubric.section.dto';
export enum RubricFieldTypeEnum {
  Text = 'TEXT',
  Number = 'NUMBER',
  Select = 'SELECT',
  MultiSelect = 'MULTI_SELECT',
  Checkbox = 'CHECKBOX',
  Radio = 'RADIO',
  TextArea = 'TEXT_AREA',
}

export interface IRubricFieldDTO extends IBaseEntityDTO {
  name: string;
  description: string;
  is_required: boolean;
  order: number;
  type: RubricFieldTypeEnum;
  options: IRubricOptionDTO[];
  section: IRubricSectionDTO;
  hasOptions(): boolean;
}

export class RubricFieldDTO extends BaseEntityDTO implements IRubricFieldDTO {
  name: string;
  description: string;
  is_required: boolean;
  order: number;
  type: RubricFieldTypeEnum;
  options: IRubricOptionDTO[];
  section: IRubricSectionDTO;

  constructor(data?: Partial<IRubricFieldDTO>) {
    super(data);
    this.name = data?.name || '';
    this.description = data?.description || '';
    this.is_required = data?.is_required ? data.is_required : false;
    this.order = data?.order || 0;
    this.type = data?.type ? data.type : RubricFieldTypeEnum.Text;
    this.options = data?.options ? data.options.map((option) => new RubricOptionDTO(option)) : [];
    this.section = new RubricSectionDTO(data?.section);
  }
  hasOptions = (): boolean => {
    return [
      RubricFieldTypeEnum.Select,
      RubricFieldTypeEnum.MultiSelect,
      RubricFieldTypeEnum.Radio,
    ].includes(this.type);
  };
}
